export interface CampaignTypeOption {
  value: string
  label: string
}

/**
 * Tipos reales de campaña de Leadcentre (tag entre corchetes en el nombre,
 * ver SOP Lead Centre & Legal), verificados contra los 476 registros
 * reales de leadcentre_data.json — suman exactamente el total, sin
 * residuo, así que "OTHER" ya no debería mostrar nada con estos 7 tags.
 *
 * "CLICKOUT" se eliminó de esta lista: pertenece a las campañas de
 * plataformas de medios, nunca aparece en Leadcentre (0 de 476 registros)
 * — como opción de filtro para esta fuente siempre devolvía cero
 * resultados.
 *
 * Los valores van entre corchetes literales ("[LB]", no "LB" a secas):
 * "LB" como subcadena libre colisiona con nombres de cliente reales que
 * contienen esas dos letras (ej. "FELBERG1493"). Debe coincidir con
 * KNOWN_CAMPAIGN_TYPE_TAGS en backend/src/config/campaignTypes.ts.
 *
 * Antes esta misma lista estaba duplicada en 8 sitios del frontend
 * (Facebook/Google/Microsoft/TikTok/Media/CampaignsDetails/RevenuePerDay/
 * FilterBar), cada uno con su propia copia desactualizada.
 */
export const CAMPAIGN_TYPE_OPTIONS: CampaignTypeOption[] = [
  { value: 'all', label: 'Todos los tipos' },
  { value: '[SPONSOR]', label: 'SPONSOR' },
  { value: '[COREGISTRO]', label: 'COREGISTRO' },
  { value: '[MARKETPLACE]', label: 'MARKETPLACE' },
  { value: '[LB]', label: 'Listbroking' },
  { value: '[PURPOSE SMARKIO]', label: 'Purpose Smarkio' },
  { value: '[PURPOSE SENDER GLOBAL]', label: 'Purpose Sender Global' },
  { value: '[COMMERCIAL SENDER GLOBAL]', label: 'Commercial Sender Global' },
  { value: 'OTHER', label: 'OTHER' },
]
